import {
  MEDICATIONS_CARD,
  PAIN_CONDITIONS_CARD,
  PAIN_GUIDE_CARD,
  RECENT_RECORDS_CARD,
} from '../../modules/Feed/reducer';

export default (state) => {
  let cards = state.feed.cards;
  if (!cards.some((card) => card.sortable)) {
    cards = cards.map((card) => {
      if (
        card.type === PAIN_GUIDE_CARD ||
        card.type === PAIN_CONDITIONS_CARD ||
        card.type === MEDICATIONS_CARD ||
        card.type === RECENT_RECORDS_CARD
      ) {
        card.sortable = true;
        card.collapsed = false;
      }
      if (card.type === PAIN_GUIDE_CARD) {
        card.position = 0;
      } else if (card.type === RECENT_RECORDS_CARD) {
        card.position = 1;
      } else if (card.type === PAIN_CONDITIONS_CARD) {
        card.position = 2;
      } else if (card.type === MEDICATIONS_CARD) {
        card.position = 3;
      }
      return card;
    });
    state = { ...state, feed: { ...state.feed, cards } };
    return state;
  }
  return state;
};
